export const OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'inquiry-overview',
};
export const PRODUCTS_ROUTE = {
    title: 'All Products',
    name: 'inquiry-products',
};
export const CATEGORIES_ROUTE = {
    title: 'Categories',
    name: 'inquiry-categories',
};
export const INQUIRIES_ROUTE = {
    title: 'Inquiries',
    name: 'inquiry-inquiries',
};
export const PERFORMANCE_ROUTE = {
    title: 'Mini App Performance',
    name: 'inquiry-performance',
};
export const BROADCAST_ROUTE = {
    title: 'Broadcast',
    name: 'inquiry-broadcast',
};
export const BROADCAST_ROUTE_FB = {
    title: 'FB Notification',
    name: 'inquiry-broadcast',
};
export const BROADCAST_ROUTE_SMS = {
    title: 'SMS',
    name: 'inquiry-broadcast-sms',
};
export const CUSTOMER_SEGMENT_ROUTE = {
    title: 'Customer Segment',
    name: 'inquiry-customer-segment',
};
